export const KEYBOARD_MODE_STANDARD = 'keyboard/mode/standard'
export const KEYBOARD_MODE_EMAIL = 'keyboard/mode/email'
export const KEYBOARD_MODE_PHONE = 'keyboard/mode/phone'
export const KEYBOARD_MODE_DATE = 'keyboard/mode/date'

export const KEYBOARD_LAYOUT_STANDARD = 'keyboard/layout/standard'
export const KEYBOARD_LAYOUT_EXTENDED = 'keyboard/layout/extended'
export const KEYBOARD_LAYOUT_SPECIALS = 'keyboard/layout/specials'
